import { render, staticRenderFns } from "./InnerOffer.vue?vue&type=template&id=fd1ca8ce&scoped=true"
import script from "./InnerOffer.vue?vue&type=script&lang=js"
export * from "./InnerOffer.vue?vue&type=script&lang=js"
import style0 from "./InnerOffer.vue?vue&type=style&index=0&id=fd1ca8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1ca8ce",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
